import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import Route from "@mapmycustomers/shared/types/entity/Route";
import { EntityTypesSupportingRoutes } from "@mapmycustomers/shared/types/entity/types";
import { MapFilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";

import {
  createEmptyFilterModel,
  createSimpleCondition,
  upsertSimpleConditions,
} from "@app/util/filters/utils";

const injectRouteScope = (
  filter: MapFilterModel,
  entityTypes: EntityTypesSupportingRoutes[],
  routeId: Route["id"],
  operator: FilterOperator.IN_ANY | FilterOperator.NONE_OF
): MapFilterModel => {
  return entityTypes.reduce<MapFilterModel>((result, entityType) => {
    const existingEntityFilter = result[entityType] ?? createEmptyFilterModel();
    return {
      ...result,
      [entityType]: upsertSimpleConditions(
        existingEntityFilter,
        createSimpleCondition("routes", operator, [routeId])
      ),
    };
  }, filter);
};

export default injectRouteScope;
